import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { BigFooterBodySocialNetworksBlockConfig } from '@front-platform/content-builder';
import {
  bigFooterBodySocialNetworksBlockResolveConfig,
  normalizeUnitValue,
  serializeUnitValue,
} from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
export interface BigFooterBodySocialNetworksBlockRuntimeConfig {}

export type BigFooterBodySocialNetworksBlockConfigInput = Partial<
  Omit<
    BigFooterBodySocialNetworksBlockConfig,
    keyof BigFooterBodySocialNetworksBlockRuntimeConfig
  > &
    BigFooterBodySocialNetworksBlockRuntimeConfig
>;
export type BigFooterBodySocialNetworksBlockResolvedConfig = Omit<
  BigFooterBodySocialNetworksBlockConfig,
  keyof BigFooterBodySocialNetworksBlockRuntimeConfig
> &
  Partial<BigFooterBodySocialNetworksBlockRuntimeConfig>;
export interface BigFooterBodySocialNetworksBlockContract extends ConfigComponentContract<
  BigFooterBodySocialNetworksBlockConfigInput,
  BigFooterBodySocialNetworksBlockResolvedConfig
> {}

@Component({
  selector: 'app-big-footer-body-social-networks-block',
  templateUrl: './big-footer-body-social-networks-block.component.html',
  standalone: false,
})
export class BigFooterBodySocialNetworksBlockComponent implements BigFooterBodySocialNetworksBlockContract {
  readonly config = input<BigFooterBodySocialNetworksBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    BigFooterBodySocialNetworksBlockConfig,
    BigFooterBodySocialNetworksBlockRuntimeConfig
  >(bigFooterBodySocialNetworksBlockResolveConfig, () => ({ config: this.config() }));
  get heading(): string {
    return this.resolvedConfig()['heading'] as unknown as string;
  }
  get alignment(): 'left' | 'center' {
    const value = this.resolvedConfig()['alignment'] as unknown as string;
    return value === 'center' ? 'center' : 'left';
  }
  get iconSizeCss(): string {
    const normalized = normalizeUnitValue(this.resolvedConfig()['icon_size'], {
      unit: 'px',
      value: 14,
    });
    if (!Number.isFinite(normalized.value) || normalized.value <= 0) {
      return '14px';
    }
    return serializeUnitValue(normalized);
  }
  get iconColor(): IContentBuilderFieldColor {
    return (
      (this.resolvedConfig()['icon_color'] as unknown as IContentBuilderFieldColor | undefined) ?? {
        type: 'palette',
        value: 'primary-600',
      }
    );
  }
  get facebookLink(): string {
    return this.resolvedConfig()['facebook_link'] as unknown as string;
  }
  get twitterLink(): string {
    return this.resolvedConfig()['twitter_link'] as unknown as string;
  }
  get instagramLink(): string {
    return this.resolvedConfig()['instagram_link'] as unknown as string;
  }
  get linkedinLink(): string {
    return this.resolvedConfig()['linkedin_link'] as unknown as string;
  }
  get tiktokLink(): string {
    return this.resolvedConfig()['tiktok_link'] as unknown as string;
  }
  get googleLink(): string {
    return this.resolvedConfig()['google_link'] as unknown as string;
  }

  navigateTo(url: string): void {
    window.open(url, '_blank');
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(BigFooterBodySocialNetworksBlockComponent, {
  'keyAliases': {},
});
